module.exports = __webpack_public_path__ + "media/src/assets/images/amenities_blue/bidet_toilet-699a56351ee8662f6ad4667ec053ce24.svg";